export default __webpack_public_path__ + "src/images/packages/cradle-boutique-hotel/764050817639bcd2501ba420870fe32b-3.png";